import React, { useState, useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./listConfig.css";
import axios from "axios";
import toast from "react-hot-toast";
import AddImage from "../../Global Functions/addImage"; // same as in AddBrandsModal

const AddCityConfig = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [cityData, setCityData] = useState({
    city: "",
    description: "",
    image: "",
  });

  const [settingData, setSettingData] = useState(null);

  // Fetch config data first
  useEffect(() => {
    const getConfigData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/setting/view`, {
          headers: { "Content-Type": "application/json" },
        });
        if (response.data) {
          setSettingData(response.data.data); // Ensure we store {_id, comming_soon_cities, ...}
        }
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    };
    getConfigData();
  }, [BASE_URL]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCityData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = async (event) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);
    if (responseUrl) {
      setCityData((prev) => ({
        ...prev,
        image: responseUrl,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!settingData?._id) {
      toast.error("Settings not loaded yet");
      return;
    }

    const newCity = {
      name: cityData.city,
      description: cityData.description,
      url: cityData.image,
    };

    let updatedCities;

    if (Array.isArray(settingData.comming_soon_cities) && settingData.comming_soon_cities.length > 0) {
      updatedCities = [...settingData.comming_soon_cities, newCity];
    } 
    else {
      updatedCities = [newCity];
    }

    try {
      await axios.post(
        `${BASE_URL}/setting/update`,
        {
          setting_id: settingData._id,
          comming_soon_cities: updatedCities,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      toast.success("City added successfully!");
      setCityData({ city: "", description: "", image: "" });

      // Update local state so UI refreshes without reload
      setSettingData((prev) => ({
        ...prev,
        comming_soon_cities: updatedCities,
      }));
    } catch (error) {
      console.error("Error updating config:", error?.response?.data);
      toast.error("Error adding city");
    }
  };

  return (
    <MainLayout>
      <div
        className="config_container_add"
        style={{
          gridColumn: "2/7",
          display: "grid",
          gridTemplateColumns: "repeat(2,1fr)",
          gap: "20px",
        }}
      >
        {/* Left side - City + Upload Image */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* City */}
          <div>
            <span>City</span>
            <input
              onChange={handleChange}
              className="input-class"
              name="city"
              value={cityData.city}
            />
          </div>

          {/* Upload Image */}
          <div>
            <span>Upload Image</span>
            <input
              type="file"
              accept="image/*"
              name="image"
              onChange={handleImageChange}
              className="input-class"
            />
          </div>
        </div>

        {/* Right side - Description */}
        <div>
          <span>Description</span>
          <textarea
            onChange={handleChange}
            className="input-class"
            name="description"
            value={cityData.description}
            rows={8}
            style={{ resize: "vertical" }}
          />
        </div>

        {/* Submit button - Full width */}
        <div style={{ gridColumn: "1 / -1" }}>
          <button className="button-class-white" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddCityConfig;
